import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { InputBox } from '../_components/InputBox';
import { apiConstants } from '../_constants';
import { miscService, validateEmail, validateFileSize } from '../_services/misc.service';
import { userService } from '../_services/user.service';

export const Register = ({ user }) => {
  const navigate = useNavigate();
  const [stateData, setStateData] = useState([]);
  const [userData, setUserData] = useState({
    ...user,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    // Fetch the JSON file from the public folder
    fetch('/state.json')
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((jsonData) => {
        const transformedData = {};
        jsonData.forEach((entry) => {
          const state = entry.State;
          const district = entry.District;
          // Create an array of districts for each state
          if (!transformedData[state]) {
            transformedData[state] = [];
          }
          transformedData[state].push(district);
        });
        setStateData(transformedData);
      })
      .catch((error) => {
        console.error('Error fetching the JSON file:', error);
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name == 'state' || name == 'district') {
      let { address } = userData;
      if (name == 'state') {
        setUserData({ ...userData, address: { [name]: value, district: '' } });
      } else {
        setUserData({ ...userData, address: { ...address, [name]: value } });
      }
    } else {
      setUserData({ ...userData, [name]: value });
    }
  };

  const handleSubmit = (user) => {
    setSubmitted(true);
    if (user.first_name && user.last_name && user.email && user.phone) {
      setIsLoading(true);
      if (validateEmail(user.email)) {
        userService.saveUser(user).then(
          () => {
            setIsLoading(false);
            setSubmitted(false);

            navigate('/');
          },
          (err) => {
            setIsLoading(false);
            setSubmitted(false);

            console.log(err, 'thi si ser');
          },
        );
      } else {
        setIsLoading(false);
        setError('Enter valid email');
      }
    } else {
      setIsLoading(false);
      setError('Please complete the form');
    }
  };

  const uploadFile = async (event) => {
    const file = event?.target?.files[0];
    if (await validateFileSize(file?.size)) {
      miscService.fileupload(file, file.name).then(
        (res) => {
          if (res?.data) {
            setUserData({ ...userData, profile_image: res.data });
          }
        },
        (err) => {
          console.log(err, 'this is err value');
          //   setError(err);
          //   if (err == "Your Account has been deactivated") {
          //     setLogoutVisible(true);
          //   }
          //   setIsLoading(false);
        },
      );
    } else {
      //   setImageError("Image size should be less than 2mb");
    }
  };
  return (
    <div className='container'>
      {console.log(isLoading, 'this is statedata')}
      <div className='title'>Tell us more about you</div>
      <div className='desc'>Add more details</div>
      <div className={'hide-block' + (error ? ' warning-block' : '')}>* {error}</div>
      <div className='form-group  d-flex flex-column gap-3'>
        <div className='profileimagecontainer mt-4 '>
          <label htmlFor='fileInput' className='uploadicon'>
            {userData?.profile_image ? (
              <img
                src={apiConstants.imgUrl + userData?.profile_image}
                className='user_profile_icon'
              />
            ) : (
              <img src='/img/camera_icon.png' className='camicon' />
            )}
          </label>
          <input
            type='file'
            id='fileInput'
            accept='image/*'
            onChange={uploadFile}
            style={{ display: 'none' }}
          />
        </div>

        <InputBox
          type='number'
          label='Phone'
          name='phone'
          value={userData?.phone}
          placeholder='Phone Number'
          onChange={handleChange}
          submitted={submitted}
        />
        <InputBox
          type='text'
          label='First Name'
          name='first_name'
          value={userData?.first_name}
          placeholder='First Name'
          onChange={handleChange}
          submitted={submitted}
        />
        <InputBox
          type='text'
          label='Last Name'
          name='last_name'
          value={userData?.last_name}
          placeholder='Last Name'
          onChange={handleChange}
          submitted={submitted}
        />
        <InputBox
          type='email'
          label='Email'
          name='email'
          value={userData?.email}
          placeholder='name@example.com'
          onChange={handleChange}
          submitted={submitted}
        />
        <InputBox
          type='text'
          label='Education'
          name='education'
          value={userData?.education}
          placeholder=''
          onChange={handleChange}
        />
        <InputBox
          type='text'
          label='Institution'
          name='college'
          value={userData?.college}
          placeholder='Eg: MG University'
          onChange={handleChange}
        />

        <div className='inputcontainer'>
          <div className='input_label'>State</div>
          <select
            className='select_input'
            name='state'
            onChange={handleChange}
            value={userData?.address?.state}
          >
            <option value=''>Select One</option>
            {Object.keys(stateData).map((item, index) => {
              return (
                <option value={item} key={index}>
                  {item}
                </option>
              );
            })}
          </select>
        </div>
        <div className='inputcontainer'>
          <div className='input_label'>District</div>
          <select
            className='select_input'
            onChange={handleChange}
            name='district'
            value={userData?.address?.district}
          >
            <option value=''>Select One</option>
            {stateData?.[userData?.address?.state]?.map((district, index) => {
              return (
                <option value={district} key={index}>
                  {district}
                </option>
              );
            })}
          </select>
        </div>

        <div className=' d-flex justify-content-between'>
          <div
            className='savebtn'
            onClick={() => {
              handleSubmit(userData);
            }}
          >
            Save & Proceed
          </div>
          <div className='skipbtn' onClick={() => navigate('/')}>
            Skip this step
          </div>
        </div>
      </div>
    </div>
  );
};
